import { useContext } from "react";
import { Link } from "react-router-dom";
import { Form, FormGroup } from "reactstrap";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Button from "../../../components/Button/Button";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import {
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
} from "../../../components/Block/Block";
import { authContext } from "./../../../context/AuthContext/AuthContext";
import { forgotPasswordValidation } from "./../../../utils/validation/validation";

const ForgetPasswordAuth = () => {
  const loader = useSelector((state) => state.loader);

  const { handleForgetPassword } = useContext(authContext);

  // Validation
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordValidation),
  });

  return (
    <>
      <SiteTitle title="بازیابی کلمه عبور" />

      <BlockHead>
        <BlockContent className="text-center">
          <BlockTitle tag="h4">بازیابی کلمه عبور</BlockTitle>
          <BlockDes>
            <p>
              برای بازیابی کلمه عبور، شماره موبایل خود را وارد کرده سپس کد تایید
              به همراه کلمه عبور جدید خود را وارد نمایید
            </p>
          </BlockDes>
        </BlockContent>
      </BlockHead>
      <Form className="is-alter" onSubmit={handleSubmit(handleForgetPassword)}>
        <FormGroup>
          <label className="form-label" htmlFor="phoneNumber">
            شماره موبایل
          </label>
          <div className="form-control-wrap">
            <input
              type="number"
              placeholder="شماره موبایل خود را وارد نمایید"
              className="form-control-lg form-control"
              {...register("phoneNumber")}
            />
            <ErrorMessage message={errors.phoneNumber?.message} />
          </div>
        </FormGroup>
        <FormGroup>
          <Button
            loading={loader}
            color="primary"
            type="submit"
            size="lg"
            className="btn-block"
          >
            بازیابی کلمه عبور
          </Button>
        </FormGroup>
      </Form>
      <div className="form-note-s2 text-center pt-4">
        <Link to="/auth/login">
          <strong>بازگشت به صفحه ورود</strong>
        </Link>
      </div>
    </>
  );
};

export default ForgetPasswordAuth;
